<section class="articleSection">
    <div class="parent">
        <div class="tileSection">
            <div *ngFor="let tile of contentArticle.articles" class="tiles">
                <div class="img-section">
                    <img [src]="csp.imagePrefix() + tile?.imgSrc" [alt]="tile?.adaText" role="presentation">
                </div>
                <h2 [innerHTML]="tile?.heading | safeHtml"></h2>
                <p [innerHTML]="tile?.description | safeHtml"></p>
                <div class="btn-section">
                    <button type="button" cdsButton="primary" [mktRouterLink]="tile?.buttonUrl"
                        [attr.aria-label]="((tile?.heading | adaFriendlyName: 'ariaLabel' ) + ' ' + tile?.buttonText)" target="_blank" [innerHTML]="tile?.buttonText"
                        (click)="onClickArticleCTA(tile.heading, tile.buttonText)">
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>